export default {
    actionList: {
        cancel: 'Отменить',

        statuses: {
            key11: {
                label: 'Выдать',
                confirm: 'Вы уверены, что хотите выдать заказ?',
            },
        },
    },

    allFields: {
        id: 'Номер заказа',
        status: 'Статус обработки',
        orderDateCC: 'Дата подтверждения',
        deliveryStatus: 'Статус доставки',
        payType: 'Тип оплаты',
        payStatus: 'Статус оплаты',
        dateCreate: 'Дата создания',
        timeWaiting: 'Срок ожидания заказа (в сутках)',
        sourceType: 'Источник заказа',
        userAuthorization: 'Статус пользователя',
        deliveryServiceMethod: 'Метод доставки',
        deliveryServiceType: 'Тип доставки',
        acceptanceActNumber: 'Номер АПП',
        dateShipment: 'Дата передачи в КС',
        pfm: 'Код магазина ПФМ',
        dateDone: 'Дата получения покупателем',
        orderProducts: 'Товары',
        deliverySumClient: 'Стоимость доставки',
        city: 'Населенный пункт магазина',
        address: 'Адрес магазина',
        manager: 'Менеджер',
        dateUpdate: 'Дата изменения',
        partnerOrderId: 'Номер заказа партнера',
        isTest: 'Тестовый заказ',
        actions: 'Действие',
    },

    index: {
        textFormsPre: 'Найден | Найдено | Найдено',
        textFormsPast: 'заказ | заказа | заказов',
        deliveryServiceType: 'Самовывоз',

        table: {
            th1: 'ЛК товара',
            th2: 'Кол-во, штук',
            th3: 'Стоимость, ед',
            th4: 'Стоимость товара, итого',
        },

        fieldsExcel: 'Список заказов',
        paidForPickup: 'Оплачен самовывоз',
        list: 'Список',
        pfmNotFound: 'ПФМ не найден!',
        pickupWithCashPay: 'Самовывоз с оплатой в магазине',
    },
};